/** Max product slug length (catalog import validation). */
export const CATALOG_IMPORT_MAX_SLUG_LEN = 120;

/** Second+ duplicate: `base-1`, `base-2`, … within max length. */
export function disambiguateCatalogImportSlug(
  baseSlug: string,
  duplicateIndex: number,
  maxLen = CATALOG_IMPORT_MAX_SLUG_LEN,
): string {
  const base = baseSlug.trim();
  if (duplicateIndex <= 0) return base;
  const suffix = `-${duplicateIndex}`;
  const head = base.slice(0, maxLen - suffix.length).replace(/-+$/g, '');
  return head ? `${head}${suffix}` : `produit${suffix}`;
}

/** Second+ duplicate: append ` (1)`, ` (2)`, … to display name. */
export function disambiguateCatalogImportName(name: string, duplicateIndex: number): string {
  const n = name.trim();
  if (duplicateIndex <= 0) return n;
  return `${n} (${duplicateIndex})`;
}
